<template>
    <div class="grid grid-cols-12 base-responsive-gap">
        <div class="col-span-12 md:col-span-5 order-1 md:order-2 flex items-center relative">
            <div class="absolute top-0 right-0">
                <div id="type-1-block-tooltip" class="relative">
                    <button
                        ref="tooltipControl"
                        :aria-label="$t('a11y.building_infos')"
                        aria-describedby="info-tooltip"
                        class="w-8 h-8 sm:w-10 sm:h-10 bg-black rounded-full inline-flex items-center justify-center"
                        @click="showTooltip"
                        @blur="hideTooltip"
                        @keydown.esc="hideTooltip"
                    >
                        <i class="pi pi-info text-white"></i>
                    </button>
                    <ClientOnly>
                        <Portal :selector="$device.isMobile ? 'body' : '#type-1-block-tooltip'">
                            <Transition name="fade">
                                <div
                                    v-if="isTooltipVisible"
                                    id="info-tooltip"
                                    v-closable="{
                                        exclude: ['tooltipControl'],
                                        handler: 'hideTooltip',
                                    }"
                                    role="tooltip"
                                    class="fixed sm:absolute top-0 left-0 h-screen overflow-auto sm:h-auto sm:-translate-x-full w-full sm:w-72 bg-black text-white px-4 pt-4 sm:pt-0 pb-4 z-10 bg-theme-dark type-1-block-tooltip"
                                    :class="
                                        isTooltipFlipped
                                            ? 'sm:translate-y-10 sm:rounded-bl-3xl sm:rounded-br-3xl sm:rounded-tl-3xl'
                                            : 'sm:-translate-y-full sm:rounded-bl-3xl sm:rounded-tl-3xl sm:rounded-tr-3xl'
                                    "
                                >
                                    <div class="sticky top-0 left-0 flex items-start bg-black py-4">
                                        <div
                                            aria-hidden="true"
                                            class="font-Poppins font-semibold text-2xl mr-2"
                                            style="flex: 1"
                                        >
                                            <T :t="buildingNameKey" />
                                        </div>
                                    </div>
                                    <ul class="grid grid-cols-1 gap-5">
                                        <li>
                                            <span class="uppercase mt-2"><T t="project.area" /></span>
                                            <span><T :t="buildingAreaKey" /></span>
                                        </li>
                                        <li>
                                            <span class="uppercase"><T t="project.architect" /></span>
                                            <span><T :t="buildingArchitectKey" /></span>
                                        </li>
                                        <li>
                                            <span class="uppercase"><T t="project.implementation" /></span>
                                            <span><T :t="buildingContractorKey" /></span>
                                        </li>
                                    </ul>
                                </div>
                            </Transition>
                        </Portal>
                    </ClientOnly>
                </div>
            </div>
            <img :src="img" :alt="$t(titleKey)" class="w-full" />
        </div>
        <div
            class="col-span-12 md:col-span-7 order-2 md:order-1 flex flex-col justify-center separator-border-top-line"
        >
            <h2 class="header-1 mb-4"><T :t="titleKey" /></h2>
            <div class="lead whitespace-pre-line"><T :t="descriptionKey" /></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Type1Block',
    props: {
        titleKey: {
            type: String,
            required: true,
        },
        descriptionKey: {
            type: String,
            required: true,
        },
        img: {
            type: String,
            required: true,
        },
        buildingNameKey: {
            type: String,
            required: true,
        },
        buildingAreaKey: {
            type: String,
            required: true,
        },
        buildingArchitectKey: {
            type: String,
            required: true,
        },
        buildingContractorKey: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            isTooltipVisible: false,
            isTooltipFlipped: false,
        };
    },
    methods: {
        showTooltip() {
            if (this.isTooltipVisible) {
                this.isTooltipVisible = false;
            } else {
                this.isTooltipVisible = true;
                this.isTooltipFlipped = this.$refs.tooltipControl.getBoundingClientRect().top < window.innerHeight / 2;
            }
        },
        hideTooltip() {
            this.isTooltipVisible = false;
        },
    },
};
</script>

<style scoped>
.type-1-block-tooltip.bg-theme-dark object {
    filter: invert(100%) sepia(100%) saturate(1%) hue-rotate(86deg) brightness(106%) contrast(101%);
}
</style>
